import axios from "axios";
import * as types from "../mutation-types";
import api from "@/api/api";

export const state = {
  general: {},
  reviewList: [],
  leftMenu: [],
  reviewFormProp: [],
  isSave: false,
  resultMember: [],
  canCheck: true
}

export const getters = {
  general: state => state.general,
  reviewList: state => state.reviewList,
  leftMenu: state => state.leftMenu,
  reviewFormProp: state => state.reviewFormProp,
  resultMember: state => state.resultMember,
  canCheck: state => state.canCheck
}

export const mutations = {
  // member general page data
  [types.CHECKPOINT.REVIEW_PROCESS](state, payload) {
    state.general = payload;
  },
  // waiting review list for PM, DM, BOD
  [types.CHECKPOINT.SET_REVIEW_LIST](state, payload) {
    state.reviewList = payload;
  },
  // left menu
  [types.CHECKPOINT.SET_LEFT_MENU](state, payload) {
    state.leftMenu = payload;
  },
  // get data form review
  [types.CHECKPOINT.SET_REVIEW_FORM_PROP](state, payload) {
    state.reviewFormProp = payload;
  },
  //
  SET_SAVE(state, payload) {
    state.isSave = payload;
  },
  [types.CHECKPOINT.RESULT_MEMBER](state, payload) {
    state.resultMember = payload;
  },

  SET_CAN_CHECK(state, payload) {
    state.canCheck = payload;
  }
}

export const actions = {
  // get data for member general page
  getGeneralReview({commit}) {
    return new Promise((resolve, reject) => {
      axios({
        url: api.CHECKPOINT.REVIEW_PROCESS,
        method: 'GET'
      }).then(response => {
        commit(types.CHECKPOINT.REVIEW_PROCESS, response.data ? response.data : {})
        resolve(response);
      }).catch(error => {
        reject(error);
      })
    })
  },

  // get review list for PM, DM
  getReviewList({commit}, params) {
    return new Promise((resolve, reject) => {
      axios({
        url: api.CHECKPOINT.REVIEW_LIST,
        method: 'GET',
        params
      }).then(response => {
        commit(types.CHECKPOINT.SET_REVIEW_LIST, response.data ? response.data : [])
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  
  getLeftMenu({
    commit
  }, params) {
    return new Promise((resolve, reject) => {
      axios({
        url: api.CHECKPOINT.LEFT_MENU,
        method: 'GET',
        params
      }).then(response => {
        commit(types.CHECKPOINT.SET_LEFT_MENU, response.data)
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // get prop for form assessment
  getReviewData({commit}, params) {
    return new Promise((resolve, reject) => {
      axios({
        url: api.CHECKPOINT.REVIEW_FORM,
        method: 'GET',
        params
      }).then(response => {
        commit(types.CHECKPOINT.SET_REVIEW_FORM_PROP, response.data ? response.data : [])
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  
  // submit data form review
  submitData({commit}, params) {
    return new Promise((resolve, reject) => {
      axios({
        url: api.CHECKPOINT.REVIEW_SUBMIT,
        method: 'POST',
        data: params
      }).then(response => {
        commit('SET_SAVE', true)
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  getResultMember({commit}, params) {
    return new Promise((resolve, reject) => {
      axios({
        url: api.CHECKPOINT.RESULT_MEMBER,
        method: 'GET',
        params
      }).then(response => {
        commit(types.CHECKPOINT.SET_REVIEW_FORM_PROP, response.data ? response.data : [])
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  setCanCheck({commit}, payload) {
    commit('SET_CAN_CHECK', payload)
  }
}
